document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('newsletter-popup');

  if (!popup) return;

  const dialog = popup.querySelector('.newsletter-popup__dialog');
  const overlay = popup.querySelector('.newsletter-popup__overlay');
  const closeButton = popup.querySelector('.newsletter-popup__close');
  const form = popup.querySelector('#NewsletterPopupForm');
  const honeypotInput = popup.querySelector('#NewsletterPopupWebsite');

  const liquidSuccessMessage = popup.querySelector(
    '[data-newsletter-success="true"]'
  );

  const delay = Number(popup.dataset.delay || 5000);

  /* =========================================================
     CLAVES DE ALMACENAMIENTO
     ========================================================= */

  const STORAGE_CLOSED_KEY = 'newsletter_popup_closed_at';
  const STORAGE_SUBSCRIBED_KEY = 'newsletter_popup_subscribed';
  const STORAGE_SUBMIT_KEY = 'newsletter_popup_last_submit';

  /*
   * Esta clave vive solamente durante la sesión/pestaña.
   * Nos permite saber que el envío realmente salió
   * desde nuestro popup.
   */
  const SESSION_PENDING_KEY = 'newsletter_popup_pending';

  /* =========================================================
     CONFIGURACIÓN
     ========================================================= */

  // Si lo cierra, no mostrar nuevamente durante 7 días.
  const CLOSED_COOLDOWN =
    7 * 24 * 60 * 60 * 1000;

  // Mínimo 3 segundos antes de permitir envío.
  const MIN_SUBMIT_TIME = 3000;

  // Evitar múltiples intentos seguidos.
  const SUBMIT_COOLDOWN = 30 * 1000;

  /*
   * Consideramos válido un envío pendiente solamente
   * durante 15 minutos.
   */
  const PENDING_EXPIRATION =
    15 * 60 * 1000;

  let popupOpenedAt = null;
  let previousActiveElement = null;

  /* =========================================================
     HELPERS: LOCAL STORAGE
     ========================================================= */

  function getLocalStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setLocalStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      // Continuar aunque localStorage esté bloqueado.
    }
  }

  function removeLocalStorage(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      // Continuar normalmente.
    }
  }

  /* =========================================================
     HELPERS: SESSION STORAGE
     ========================================================= */

  function getSessionStorage(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function setSessionStorage(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      // Continuar aunque sessionStorage esté bloqueado.
    }
  }

  function removeSessionStorage(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      // Continuar normalmente.
    }
  }

  /* =========================================================
     ESTADO GENERAL
     ========================================================= */

  function hasSubscribed() {
    return (
      getLocalStorage(STORAGE_SUBSCRIBED_KEY) === 'true'
    );
  }

  function wasClosedRecently() {
    const closedAt = Number(
      getLocalStorage(STORAGE_CLOSED_KEY)
    );

    if (!closedAt) return false;

    return (
      Date.now() - closedAt <
      CLOSED_COOLDOWN
    );
  }

  function submittedRecently() {
    const lastSubmit = Number(
      getLocalStorage(STORAGE_SUBMIT_KEY)
    );

    if (!lastSubmit) return false;

    return (
      Date.now() - lastSubmit <
      SUBMIT_COOLDOWN
    );
  }

  /* =========================================================
     ENVÍO PENDIENTE DEL POPUP
     ========================================================= */

  function savePendingSubmission() {
    const pendingData = {
      timestamp: Date.now(),
      path: window.location.pathname,
      scrollY: window.scrollY
    };

    setSessionStorage(
      SESSION_PENDING_KEY,
      JSON.stringify(pendingData)
    );
  }

  function getPendingSubmission() {
    const rawData =
      getSessionStorage(SESSION_PENDING_KEY);

    if (!rawData) return null;

    try {
      const data = JSON.parse(rawData);

      if (!data.timestamp) {
        removeSessionStorage(SESSION_PENDING_KEY);
        return null;
      }

      /*
       * Si pasó demasiado tiempo,
       * descartamos el intento.
       */
      if (
        Date.now() - data.timestamp >
        PENDING_EXPIRATION
      ) {
        removeSessionStorage(SESSION_PENDING_KEY);
        return null;
      }

      /*
       * También comprobamos que Shopify
       * haya regresado a la misma página.
       */
      if (
        data.path &&
        data.path !== window.location.pathname
      ) {
        return null;
      }

      return data;
    } catch (error) {
      removeSessionStorage(SESSION_PENDING_KEY);
      return null;
    }
  }

  /* =========================================================
     DETECTAR RESPUESTA DE SHOPIFY
     ========================================================= */

  const urlParams =
    new URLSearchParams(window.location.search);

  const shopifyCustomerPosted =
    urlParams.get('customer_posted') === 'true';

  const pendingSubmission =
    getPendingSubmission();

  /*
   * Consideramos éxito si:
   *
   * A) Liquid confirma posted_successfully?
   *
   * O
   *
   * B) Shopify regresó con customer_posted=true
   *    Y nosotros sabemos que el envío salió
   *    de nuestro popup.
   */
  const successfulSignup =
    Boolean(liquidSuccessMessage) ||
    Boolean(
      shopifyCustomerPosted &&
      pendingSubmission
    );

  /* =========================================================
     ESTADO VISUAL DE ÉXITO
     ========================================================= */

  function showSuccessState() {
    const textContainer = popup.querySelector(
      '.newsletter-popup__text'
    );

    if (!textContainer) return;

    textContainer.innerHTML = `
      <div
        class="newsletter-popup__success"
        role="status"
        data-newsletter-success="true"
      >
        <h3>¡Registro exitoso! 🎉</h3>

        <p>
          Gracias por ser parte de<br>
          PupilentesYA 😍
        </p>
      </div>
    `;
  }

  /* =========================================================
     LIMPIAR URL DESPUÉS DEL ÉXITO
     ========================================================= */

  function cleanShopifySuccessUrl() {
    const url = new URL(window.location.href);

    url.searchParams.delete(
      'customer_posted'
    );

    /*
     * Shopify puede agregar un fragmento
     * como #NewsletterPopupForm.
     */
    if (
      url.hash === '#NewsletterPopupForm' ||
      url.hash === '#contact_form'
    ) {
      url.hash = '';
    }

    const cleanUrl =
      url.pathname +
      (url.searchParams.toString()
        ? '?' + url.searchParams.toString()
        : '') +
      url.hash;

    window.history.replaceState(
      {},
      document.title,
      cleanUrl
    );
  }

  /* =========================================================
     MOSTRAR / OCULTAR
     ========================================================= */

  function shouldShowPopup() {
    /*
     * Después de una suscripción exitosa,
     * sí lo mostramos una última vez para
     * enseñar el mensaje de agradecimiento.
     */
    if (successfulSignup) {
      return true;
    }

    if (hasSubscribed()) {
      return false;
    }

    if (wasClosedRecently()) {
      return false;
    }

    return true;
  }

  function openPopup() {
    if (!shouldShowPopup()) return;

    previousActiveElement =
      document.activeElement;

    popupOpenedAt = Date.now();

    popup.classList.add('is-active');

    document.body.classList.add(
      'newsletter-popup-open'
    );

    const currentEmailInput =
      popup.querySelector(
        '#NewsletterPopupEmail'
      );

    if (currentEmailInput) {
      window.setTimeout(function () {
        currentEmailInput.focus();
      }, 100);
    } else if (closeButton) {
      window.setTimeout(function () {
        closeButton.focus();
      }, 100);
    }
  }

  function closePopup(saveClosedState = true) {
    popup.classList.remove('is-active');

    document.body.classList.remove(
      'newsletter-popup-open'
    );

    /*
     * Después de una suscripción exitosa
     * no necesitamos registrar "cerrado".
     */
    if (
      saveClosedState &&
      !successfulSignup
    ) {
      setLocalStorage(
        STORAGE_CLOSED_KEY,
        String(Date.now())
      );
    }

    if (
      previousActiveElement &&
      typeof previousActiveElement.focus ===
        'function'
    ) {
      previousActiveElement.focus();
    }
  }

  /* =========================================================
     VALIDACIÓN EMAIL
     ========================================================= */

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
      email
    );
  }

  /* =========================================================
     CIERRE
     ========================================================= */

  if (closeButton) {
    closeButton.addEventListener(
      'click',
      function () {
        closePopup(true);
      }
    );
  }

  if (overlay) {
    overlay.addEventListener(
      'click',
      function () {
        closePopup(true);
      }
    );
  }

  /* =========================================================
     ACCESIBILIDAD
     ========================================================= */

  function handleKeydown(event) {
    if (
      !popup.classList.contains(
        'is-active'
      )
    ) {
      return;
    }

    if (event.key === 'Escape') {
      closePopup(true);
      return;
    }

    if (
      event.key === 'Tab' &&
      dialog
    ) {
      const focusableElements =
        dialog.querySelectorAll(
          'button:not([disabled]), input:not([disabled]):not([tabindex="-1"]), a[href], select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );

      if (!focusableElements.length) {
        return;
      }

      const firstElement =
        focusableElements[0];

      const lastElement =
        focusableElements[
          focusableElements.length - 1
        ];

      if (
        event.shiftKey &&
        document.activeElement ===
          firstElement
      ) {
        event.preventDefault();

        lastElement.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement ===
          lastElement
      ) {
        event.preventDefault();

        firstElement.focus();
      }
    }
  }

  document.addEventListener(
    'keydown',
    handleKeydown
  );

  /* =========================================================
     SUSCRIPCIÓN EXITOSA
     ========================================================= */

  if (successfulSignup) {
    /*
     * Ya consideramos a este navegador
     * como suscrito.
     */
    setLocalStorage(
      STORAGE_SUBSCRIBED_KEY,
      'true'
    );

    removeLocalStorage(
      STORAGE_CLOSED_KEY
    );

    removeLocalStorage(
      STORAGE_SUBMIT_KEY
    );

    /*
     * Ya no necesitamos la marca temporal.
     */
    removeSessionStorage(
      SESSION_PENDING_KEY
    );

    /*
     * Si Liquid no pudo mantener
     * posted_successfully? después de hCaptcha,
     * construimos nosotros el mensaje.
     */
    if (!liquidSuccessMessage) {
      showSuccessState();
    }

    /*
     * Quitamos customer_posted=true
     * para dejar una URL limpia.
     */
    cleanShopifySuccessUrl();

    /*
     * Restauramos aproximadamente el punto
     * donde estaba el visitante antes del envío.
     */
    if (
      pendingSubmission &&
      typeof pendingSubmission.scrollY ===
        'number'
    ) {
      window.requestAnimationFrame(
        function () {
          window.scrollTo(
            0,
            pendingSubmission.scrollY
          );
        }
      );
    }

    /*
     * Mostrar inmediatamente el agradecimiento.
     */
    openPopup();

    return;
  }

  /* =========================================================
     ENVÍO DEL FORMULARIO
     ========================================================= */

  if (form) {
    form.addEventListener(
      'submit',
      function (event) {
        const currentEmailInput =
          popup.querySelector(
            '#NewsletterPopupEmail'
          );

        const email = currentEmailInput
          ? currentEmailInput.value.trim()
          : '';

        /* -----------------------------------------
           HONEYPOT
           ----------------------------------------- */

        if (
          honeypotInput &&
          honeypotInput.value.trim() !== ''
        ) {
          event.preventDefault();
          return;
        }

        /* -----------------------------------------
           EMAIL
           ----------------------------------------- */

        if (!isValidEmail(email)) {
          event.preventDefault();

          if (currentEmailInput) {
            currentEmailInput.setCustomValidity(
              'Este correo no es válido.'
            );

            currentEmailInput.reportValidity();

            window.setTimeout(
              function () {
                currentEmailInput.setCustomValidity(
                  ''
                );
              },
              100
            );
          }

          return;
        }

        /* -----------------------------------------
           TIEMPO MÍNIMO
           ----------------------------------------- */

        if (
          popupOpenedAt &&
          Date.now() - popupOpenedAt <
            MIN_SUBMIT_TIME
        ) {
          event.preventDefault();

          if (currentEmailInput) {
            currentEmailInput.setCustomValidity(
              'Espera unos segundos e intenta nuevamente.'
            );

            currentEmailInput.reportValidity();

            window.setTimeout(
              function () {
                currentEmailInput.setCustomValidity(
                  ''
                );
              },
              100
            );
          }

          return;
        }

        /* -----------------------------------------
           ENVÍOS REPETIDOS
           ----------------------------------------- */

        if (submittedRecently()) {
          event.preventDefault();

          if (currentEmailInput) {
            currentEmailInput.setCustomValidity(
              'Ya se realizó un intento recientemente. Espera unos segundos.'
            );

            currentEmailInput.reportValidity();

            window.setTimeout(
              function () {
                currentEmailInput.setCustomValidity(
                  ''
                );
              },
              100
            );
          }

          return;
        }

        /* -----------------------------------------
           REGISTRAR INTENTO
           ----------------------------------------- */

        setLocalStorage(
          STORAGE_SUBMIT_KEY,
          String(Date.now())
        );

        /*
         * Este es el cambio importante:
         * recordamos que ESTE formulario
         * fue el que inició la suscripción.
         */
        savePendingSubmission();

        /*
         * A partir de aquí no impedimos
         * el submit. Shopify y hCaptcha
         * continúan normalmente.
         */
      }
    );
  }

  /* =========================================================
     APERTURA NORMAL
     ========================================================= */

  if (shouldShowPopup()) {
    window.setTimeout(
      openPopup,
      delay
    );
  }
});